const Divider = ({ className }: { className?: string }) => (
  <div className={`border-b ${className}`} />
)

export default Divider
